import { ACTIONS } from '@veeam/core';
/**
 * The function do enable Toolbar item if payload props has at least one selected item.
 */
export var disallowWithoutSelection = function () { return function (payload) { return ({
    disabled: !(payload.selectedItems || []).length
}); }; };
/**
 * The function do enable button type item if `payload` props has only one selected item.
 */
export var disallowWithoutSingleSelection = function () { return function (payload) { return ({
    disabled: (payload.selectedItems || []).length !== 1
}); }; };
/**
 * The function do disable button type item if `payload` props has only one selected item.
 */
export var disallowWithoutMultipleSelection = function () { return function (payload) { return ({
    disabled: (payload.selectedItems || []).length === 1
}); }; };
/**
 * The function do enable button type item if `payload` props has only one selected enabled item.
 */
export var disallowWithoutEnabling = function () { return function (payload, api) {
    var disabled = disallowWithoutSingleSelection()(payload, api).disabled;
    if (!disabled) {
        return {
            disabled: (payload.selectedItems || []).some(function (item) { return item.disabled; })
        };
    }
    return {
        disabled: disabled
    };
}; };
/**
 * The function do enable button type item if `payload` props has at least one selected enabled item.
 */
export var disallowWithoutMultiEnabling = function () { return function (payload, api) {
    var disabled = disallowWithoutSelection()(payload, api).disabled;
    if (!disabled) {
        return {
            disabled: (payload.selectedItems || []).some(function (item) { return item.disabled; })
        };
    }
    return {
        disabled: disabled
    };
}; };
/**
 * The function do enable button type item if `payload` props has only one selected disabled item.
 */
export var disallowWithoutDisabling = function () { return function (payload, api) {
    var disabled = disallowWithoutSingleSelection()(payload, api).disabled;
    if (!disabled) {
        return {
            disabled: !(payload.selectedItems || []).some(function (item) { return item.disabled; })
        };
    }
    return {
        disabled: disabled
    };
}; };
/**
 * The function do enable button type item if `payload` props has at least one selected disabled item.
 */
export var disallowWithoutMultiDisabling = function () { return function (payload, api) {
    var disabled = disallowWithoutSelection()(payload, api).disabled;
    if (!disabled) {
        return {
            disabled: !(payload.selectedItems || []).every(function (item) { return item.disabled; })
        };
    }
    return {
        disabled: disabled
    };
}; };
/**
 * The function do enable button type item if `payload` props has only one selected item with an object containing the [key] property with a logical true value.
 */
export var disallowWithoutValueByKey = function (key) { return function (payload, api) {
    var disabled = disallowWithoutSingleSelection()(payload, api).disabled;
    if (!disabled) {
        return {
            disabled: (payload.selectedItems || []).some(function (item) { return !item[key]; })
        };
    }
    return {
        disabled: disabled
    };
}; };
/**
 * The function do enable button type item if `payload` props has only one selected item that does not contain the [key] property with a logical true value.
 */
export var allowWithoutValueByKey = function (key) { return function (payload, api) {
    var disabled = disallowWithoutSingleSelection()(payload, api).disabled;
    if (!disabled) {
        return {
            disabled: (payload.selectedItems || []).some(function (item) { return !!item[key]; })
        };
    }
    return {
        disabled: disabled
    };
}; };
/**
 * The function do hide button type item if `payload` props have `flags` property with [flagKey] property and value of [flagKey] property is true.
 */
export var hideByFlag = function (flagKey) { return function (payload) { return ({
    hidden: payload.flags && payload.flags[flagKey]
}); }; };
/**
 * The function do display button type item if `payload` props have `flags` property with [flagKey] property and value of [flagKey] property is true.
 */
export var showByFlag = function (flagKey) { return function (payload) { return ({
    hidden: !(payload.flags && payload.flags[flagKey])
}); }; };
export function disallowByGuard(resourceName, action) {
    if (action === void 0) { action = ACTIONS.Write; }
    return function (payload, api) { return ({
        disabled: !api.canAction(action, resourceName)
    }); };
}
export function hideByGuard(resourceName, action) {
    if (action === void 0) { action = ACTIONS.Write; }
    return function (payload, api) { return ({
        hidden: !api.canAction(action, resourceName)
    }); };
}
//# sourceMappingURL=toolbarItemDecorators.js.map